<ng-select (change)="onSelectElement()" (scrollToEnd)="onGetMoreItems()" (search)="onSearch($event)"
    [(ngModel)]="acte_id" placeholder="Choisissez police " name="acte_id" id="acte_id"
    [multiple]="false" [closeOnSelect]="true">
    <ng-option *ngFor="let item of items" [value]="item.id">{{ item.libelle}}
    </ng-option>
</ng-select>